
import {Component, Vue, Prop, Watch, Model} from 'vue-property-decorator';
export interface SelectDataItem {
    label: string;
    value: string;
}
@Component
export default class ScrollSelect extends Vue {
    // @Model('input', {type: String, default: ''}) public value!: string;
    @Prop({default: () => []}) datas!: SelectDataItem[];
    @Prop({default: () => 50}) pageSize!: number;
    @Prop({default: undefined}) value!: string;
    loading = false;
    totalPage = 1;
    scrollPage = 1;
    options: SelectDataItem[] = [];

    @Watch('datas')
    handleDataChange(nv: SelectDataItem[]) {
        if (nv && nv.length) {
            const options = nv.slice(0, this.pageSize * 1);
            const index = options.findIndex(x => x.value === this.value);
            this.scrollPage = 1;
            // 兼容选中值不在第一页的情况
            if (this.value && index < 0) {
                const end = Math.ceil((nv.findIndex(x => x.value === this.value) + 1) / this.pageSize);
                this.scrollPage = end;
            }
            this.options = nv.slice(0, this.pageSize * this.scrollPage);
            this.totalPage = Math.ceil(nv.length / this.pageSize);
            return;
        }
        this.options = [];
        this.totalPage = 0;
    }
    setData() {
        if (this.scrollPage === 1) {
            this.options = [];
        }
        this.options = this.options.concat(this.datas.slice(this.pageSize * (this.scrollPage - 1), this.pageSize * this.scrollPage));
    }
    async handlePopupScroll(event: {target: HTMLInputElement & EventTarget}) {
        const target = event.target;
        if (!this.loading && target.scrollTop + target.offsetHeight === target.scrollHeight) {
            if (this.totalPage <= this.scrollPage) {
                return;
            }
            this.loading = true;
            target.scrollTo(0, target.scrollHeight);
            this.scrollPage++;
            this.setData();
            this.loading = false;
        }
    }
    filterOption(input: string, option: any) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
}
